import * as React from "react";
import Testo from '../elementi/Testo'
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Alert from "@mui/material/Alert";
import Input from "@mui/material/Input";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import DragHandleIcon from "@mui/icons-material/DragHandle";

import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import EmailIcon from "@mui/icons-material/Email";
import { monFetch } from "../inc/inc";

export default function Comp(props) {
  const [email, setEmail] = useState("");
  const [errore, setErrore] = useState(false);
  const [mexErrore, setMexErrore] = useState(null);
  const [mexOk, setMexOk] = useState(null);

  const [segnoOperazione, setSegnoOperazione] = useState(null);
  const [primoValore, setPrimoValore] = useState("");
  const [secondoValore, setSecondoValore] = useState("");
  const [risultatoCaptcha, setRisultatoCaptcha] = useState("");

  async function checkCaptcha(e) {
    e.preventDefault();
    const res = await monFetch("/forgot", {
      valore1: primoValore,
      valore2: secondoValore,
      operazione: segnoOperazione,
      risultato: risultatoCaptcha,
      email: email,
    });

    if (!res.success) {
      setErrore(true);
      setMexOk(false);
      setMexErrore(res.messaggio);
    } else {
      setErrore(false);
      setMexOk(res.messaggio);
    }
  }

  function captcha_init() {
    var a = Math.floor(Math.random() * 10) + 11;
    var b = Math.floor(Math.random() * 10) + 1;
    var c = Math.floor(Math.random() * 2);

    setPrimoValore(a);
    setSecondoValore(b);

    if (c == 0) {
      setSegnoOperazione(0);
    } else {
      setSegnoOperazione(1);
    }
  }

  useEffect(() => {
    captcha_init();
  }, []);

  return (
    <div className="flexContCenter">
      <div className="boxlogin">
        <a href={process.env.PUBLIC_URL + "/login"}>
          <img src={process.env.PUBLIC_URL + "/img/logo.png"} />
        </a>
        <form onSubmit={(e) => checkCaptcha(e)}>
          <Grid container spacing={2}>
            {!mexOk && (
              <Grid item xs={12}>
                <h2>Recupera Password</h2>
                <Testo
                  className="email"
                  label="email"
                  type="email"
                  value={email}
                  icona={<EmailIcon />}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Grid>
            )}
            {!mexOk && (
              <Grid item xs={12}>
                <div className="messages"></div>

                <div className="form-inline captcha">
                  <span>Dimostra di non essere una macchina!</span>
                  <br />
                  <Input
                    name="frm-check-a"
                    value={primoValore}
                    variant="filled"
                    id="frm-check-a"
                    readOnly={true}
                    style={{ width: "50px" }}
                  />
                  <span id="frm-check-c-span">
                    {segnoOperazione == 0 ? (
                      <RemoveIcon style={{ verticalAlign: "middle" }} />
                    ) : (
                      <AddIcon style={{ verticalAlign: "middle" }} />
                    )}
                  </span>
                  <Input
                    name="frm-check-b"
                    value={secondoValore}
                    variant="filled"
                    id="frm-check-b"
                    readOnly={true}
                    style={{ width: "50px" }}
                  />
                  <span>
                    <DragHandleIcon style={{ verticalAlign: "middle" }} />
                  </span>
                  <Input
                    name="frm-check-res"
                    value={risultatoCaptcha}
                    variant="filled"
                    onChange={(e) => setRisultatoCaptcha(e.target.value)}
                    id="frm-check-res"
                    style={{ width: "50px" }}
                    required={true}
                    data-msg-required="Campo di controllo obbligatorio"
                  />
                  <label
                    id="frm-check-res-error"
                    htmlFor="frm-check-res"
                    className="error invalid-feedback"
                  ></label>
                </div>
              </Grid>
            )}

            <Grid item xs={12}>
              {errore && (
                <>
                  <br />
                  <Alert severity="error" sx={{ mb: 2 }}>
                    {mexErrore}
                  </Alert>
                </>
              )}
              {mexOk && (
                <>
                  <br />
                  <Alert severity="success" sx={{ mb: 2 }}>
                    <span dangerouslySetInnerHTML={{ __html: mexOk }}></span>
                  </Alert>
                </>
              )}
              {!mexOk && (
                <Button variant="contained" type="submit" fullWidth>
                  Invia Mail di recupero
                </Button>
              )}
            </Grid>
            <Grid item xs={12}>
              <p style={{ textAlign: "center" }}>
                <a href={process.env.PUBLIC_URL + "/login"}>
                  <AccountCircleIcon
                    style={{ verticalAlign: "middle", marginRight: "5px" }}
                  />
                  <span style={{ verticalAlign: "middle" }}>
                    Torna al login
                  </span>
                </a>
              </p>
            </Grid>
          </Grid>
        </form>
      </div>
    </div>
  );
}
